import Ajv from "ajv";

import { lvtResponseSchema } from "../common";


const cameraOrCabinetMetadataProperties = {
    record: {
        type: "object",
        items: {
            oneOf: [
                {
                    properties: {
                        id: { type: "number" },
                        name: { type: "string" },
                        notRecordingReason: { type: ["string", "null"] },
                        clientId: { type: ["number", "null"] },
                    },
                },
                {
                    properties: {
                        id: { type: "number" },
                        name: { type: "string" },
                        notRecordingReason: { type: ["string", "null"] },
                        clientId: { type: ["number", "null"] },
                        canRequestVideo: { type: "boolean" },
                    },
                },
            ],
        },
    },
    archivedVideos: {
        type: "array",
        items: {
            type: "object",
            additionalProperties: false,
            properties: {
                id: { type: "number" },
                cameraId: { type: ["number", "null"] },
                archiveCabinetId: { type: ["number", "null"] },
                title: { type: ["string", "null"] },
                url: { type: ["string", "null"] },
                bytes: { type: ["number", "null"] },
                timestampRecorded: { type: ["string", "null"] },
                timestampRequested: { type: ["string", "null"] },
                requestedDurationMinutes: { type: ["number", "null"] },
            },
        },
    },
    presets: {
        type: "array",
        items: {
            type: "object",
            additionalProperties: false,
            properties: {
                id: { type: "number" },
                cameraId: { type: ["number", "null"] },
                archiveCabinetId: { type: ["number", "null"] },
                name: { type: ["string", "null"] },
                default: { type: "boolean" },
            },
        },
    },
};

const cameraOrCabinetMetadataSchema = {
    type: "array",
    items: {
        type: "object",
        additionalProperties: false,
        required: Object.keys(cameraOrCabinetMetadataProperties),
        properties: cameraOrCabinetMetadataProperties,
    },
};

export const cameraMetadataValidator = new Ajv().compile(cameraOrCabinetMetadataSchema);

const lvtResponseCameraOrCabinetMetadataSchema = lvtResponseSchema(cameraOrCabinetMetadataSchema);

export const lvtResponseCameraOrCabinetMetadataValidator = new Ajv().compile(lvtResponseCameraOrCabinetMetadataSchema);
